module.exports = __webpack_public_path__ + "media/images/map-icon-c7f552608bde1ab67058bfff1c31f0b5.svg";